import { AvailableLanguageOnApp, LocalesDict } from "./types/i18n.types";

export const isAvailableLanguageOnApp = (
  lang: string
): lang is AvailableLanguageOnApp => {
  return Object.values(LocalesDict).includes(lang as LocalesDict);
};

export const funnelLangUsage = (lang: string): AvailableLanguageOnApp => {
  if (isAvailableLanguageOnApp(lang)) {
    return lang;
  } else {
    console.log(
      `Language ${lang} not handled for now. Using ${LocalesDict.ENGLISH_US}.`
    );
    return LocalesDict.ENGLISH_US;
  }
};
